export const NumberFormat = (number) => {
  return ((number * 100) / 100).toFixed(2);
};

export const CalcTime = (time) => {
  return (Date.now() - new Date(time).getTime()) / (1000 * 3600 * 24) > 1
    ? true
    : false;
};
